export const restaurantVariantColumns = [
  {
    Header: "Variant Name",
    accessor: "name",
  },
  {
    Header: "Flavor",
    accessor: "flavor",
  },
  {
    Header: "Size",
    accessor: "size",
  },
  // {
  //   Header: "Quantity",
  //   accessor: "quantity",
  // },
  {
    Header: "Price",
    accessor: "price",
  },
  {
    Header: "Created on",
    accessor: "created_at",
  },
  // {
  //   Header: "Category",
  //   accessor: "category",
  // },
  {
    Header: "Dish",
    accessor: "sub_Category",
  },
  {
    Header: "Action",
    accessor: "actions",
  },
];
